import { formatMoney, MONEY_SCALE, parseHumanAmount } from '@aeris/money'
import type { ColumnFilterValue } from '@aeris/ui'

/**
 * As pontes entre o estado da tela e o filtro de coluna — F152.
 *
 * As telas guardam o filtro no formato que a CONSULTA quer (`''` para "sem
 * filtro", a string decimal do valor). O menu de cabeçalho fala outro formato,
 * que é o dele. Estas funções são a tradução, escrita uma vez: em quatro telas,
 * quatro traduções à mão divergiriam no primeiro conserto.
 */

export const enumValue = (value: string): ColumnFilterValue => ({
  kind: 'enum',
  value,
})

export const textValue = (text: string): ColumnFilterValue => ({
  kind: 'text',
  text,
})

const money = (wire: string): string => {
  const amount = parseHumanAmount(wire.replace('.', ','), MONEY_SCALE)
  return amount === null ? wire : formatMoney(amount)
}

/**
 * Como a faixa se lê num chip.
 *
 * As três formas existem porque as três são filtros legítimos: só mínimo, só
 * máximo, e os dois. "de R$ 500" e "até R$ 500" dizem coisas opostas, e um
 * rótulo único do tipo "R$ 500" não distinguiria as duas.
 */
export const rangeLabel = (min: string, max: string): string => {
  if (min !== '' && max !== '') return `de ${money(min)} a ${money(max)}`
  if (min !== '') return `de ${money(min)}`
  return `até ${money(max)}`
}

/**
 * A mesma leitura, para quantidade.
 *
 * Sem o `R$`, e sem esconder o sinal: "de -5 a 0" é o filtro de quem vai
 * acertar o estoque, e trocar o menos por nada aqui viraria outro filtro.
 */
export const quantityRangeLabel = (min: string, max: string): string => {
  if (min !== '' && max !== '') return `de ${min} a ${max}`
  if (min !== '') return `de ${min}`
  return `até ${max}`
}
